import { SET_CLIENT_TYPE, SET_COUNTRY, SET_USER_TOKEN } from './constants'

const initialState = {
  country: null,
  clientType: null,
  userToken: null
}

const app = (state = initialState, action) => {
  switch (action.type) {
    case SET_COUNTRY:
      return {
        ...state,
        country: action.payload
      }
    case SET_CLIENT_TYPE:
      return {
        ...state,
        clientType: action.payload
      }
    case SET_USER_TOKEN:
      return {
        ...state,
        userToken: action.payload
      }
    default:
      return state
  }
}

export default app
